<template>
  <th
    class="table-v2__header-cell"
    :class="{
      'table-v2__header-cell--active': isDropdownOpen,
    }"
    :style="cellStyle"
  >
    <div class="table-v2__header-content">
      <slot name="custom-title">
        <span class="table-v2__header-title" :title="title">{{ title }}</span>
      </slot>
      <button
        v-if="showMenu"
        class="table-v2__header-menu-btn"
        @click.stop="$emit('toggle-dropdown')"
      >
        <v2-icon icon="more_vert" />
        <span v-if="filtered" class="table-v2__header-menu-dot" />
      </button>
    </div>
    <div
      v-if="isDropdownOpen"
      v-on-clickaway="onClickAway"
      class="table-v2__dropdown"
      @click.stop
    >
      <slot name="dropdown" />
    </div>
  </th>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import V2Icon from 'v2/components/Icon.vue';

export default {
  name: 'TableHeaderCellV2',
  components: { V2Icon },
  mixins: [clickaway],
  props: {
    title: {
      type: String,
      default: '',
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
    isDropdownOpen: {
      type: Boolean,
      default: false,
    },
    filtered: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: '',
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    cellStyle() {
      const style = {};
      if (this.width) {
        style.width =
          typeof this.width === 'number' ? `${this.width}px` : this.width;
      }
      if (this.align) {
        style.textAlign = this.align;
      }
      return style;
    },
  },
  methods: {
    onClickAway() {
      if (this.isDropdownOpen) {
        this.$emit('close-dropdown');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-v2__header-cell {
  background: theme('colors.neutral.200');
  color: #717171;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  letter-spacing: 0;
  padding: 8px 12px;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
}

.table-v2__header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
}

.table-v2__header-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-v2__header-menu-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 4px;
  padding: 0;
  border: none;
  background: transparent;
  line-height: 1;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
}

.table-v2__header-menu-dot {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: theme('colors.brand.DEFAULT');
}

.table-v2__header-cell--active .table-v2__header-menu-btn {
  background: theme('colors.neutral.300');
}

.table-v2__dropdown {
  position: absolute;
  top: 100%;
  right: 12px;
  z-index: 100;
  min-width: max-content;
  background: theme('colors.white');
  border: 1px solid theme('colors.gray.200');
  border-radius: 8px;
  box-shadow: none;
  padding: 4px 0;
  margin-top: -2px;

  .table-v2--rtl & {
    right: auto;
    left: 12px;
  }
}

.table-v2__header-cell:first-child .table-v2__dropdown {
  right: auto;
  left: 0;

  .table-v2--rtl & {
    left: auto;
    right: 0;
  }
}
</style>
